import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 323,
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
}));

export default useStyles;
